import PageHeader from "./style";
import React from "react";

const MobilePageHeader = ({ children }) => <PageHeader>{children}</PageHeader>;

export default MobilePageHeader;
